<!--    //FUNCTION IN TEMPLATE-->
@if (data.asset.mimeType.startsWith('image')) {
    <img class="max-image" [src]="data.asset.url">
} @else {
    <video [src]="data.asset.url" controls></video>
}
<ng-template #video>
    <video [src]="data.asset.url" controls></video>
</ng-template>
